import { useMutation } from 'react-query';
import { generateAiReport } from '../services';

export const useGenerateAIReportMutation = () => {
  const mutation = useMutation( ['v2', 'session-report-ai'], generateAiReport );

  return mutation;
};
